import {

  createContext,

  useCallback,

  useContext,

  useEffect,

  useMemo,

  useState,

  type ReactNode,

} from "react";

import { useLocation } from "react-router";

import type { OutreachLaunchParams } from "../../utils/outreachNavigation";

import { OutreachWorkspaceOverlay } from "./OutreachWorkspaceOverlay";



type OutreachContextValue = {
  isOpen: boolean;

  launchOutreach: (params: OutreachLaunchParams) => void;

  closeOutreach: () => void;

};



const OutreachContext = createContext<OutreachContextValue | null>(null);



export const OutreachProvider = ({ children }: { children: ReactNode }) => {

  const location = useLocation();

  const [workspace, setWorkspace] = useState<OutreachLaunchParams | null>(null);



  const closeOutreach = useCallback(() => {

    setWorkspace(null);

  }, []);



  useEffect(() => {

    closeOutreach();

  }, [location.pathname, closeOutreach]);



  const launchOutreach = useCallback((params: OutreachLaunchParams) => {

    setWorkspace(params);

  }, []);



  const value = useMemo(

    () => ({ launchOutreach, closeOutreach, isOpen: !!workspace }),

    [launchOutreach, closeOutreach, workspace]

  );



  return (

    <OutreachContext.Provider value={value}>

      {children}

      {workspace ? (

        <OutreachWorkspaceOverlay params={workspace} onClose={closeOutreach} />

      ) : null}

    </OutreachContext.Provider>

  );

};



export function useOutreach(): OutreachContextValue {

  const context = useContext(OutreachContext);

  if (!context) {

    throw new Error("useOutreach must be used within OutreachProvider");

  }

  return context;

}
